import { Check } from "lucide-react";
import Reveal from "@/components/Reveal";

const POINTS = [
  "Colloqui senza fretta: il tempo che serve a te",
  "Abbatto le paure con parole semplici",
  "Nessun imbarazzo: metto tutti al proprio agio",
  "Prima l'ascolto, poi la cura",
];

export default function Approach() {
  return (
    <section id="approccio" className="relative py-28 overflow-hidden">
      <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-gold/5 blur-[140px]" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -inset-3 rounded-[2.2rem] border border-sagelight/25 -translate-x-4 translate-y-4" />
          <div className="relative rounded-[2rem] overflow-hidden border border-gold/25 bg-elevated/70 backdrop-blur px-8 sm:px-12 py-14 sm:py-16 min-h-[420px] flex flex-col justify-center">
            <svg viewBox="0 0 64 64" className="absolute -right-8 -bottom-10 w-56 h-56 opacity-[0.07]" aria-hidden="true">
              <circle cx="32" cy="32" r="30" fill="none" stroke="#D4A359" strokeWidth="1" />
              <text x="32" y="41" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontStyle="italic" fontSize="26" fill="#D4A359">RD</text>
            </svg>
            <span className="eyebrow">Il metodo Di Lorenzo</span>
            <p className="font-display text-3xl sm:text-4xl leading-snug mt-6 text-ivory relative z-10">
              Nessun tabù. Nessuna paura. <span className="italic text-gold">Solo un colloquio sereno.</span>
            </p>
            <div className="flex flex-wrap gap-3 mt-10 relative z-10">
              {["30+ anni di esperienza", "Attenzione al comfort del paziente", "Recupero rapido quando appropriato"].map((c) => (
                <span key={c} className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-silver border border-white/10 rounded-full px-4 py-2 bg-ink/50">
                  <span className="inline-block w-1.5 h-1.5 rotate-45 bg-gold" /> {c}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="eyebrow">L'approccio</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight">
              Empatia prima della cura. <span className="italic text-gold">Sempre.</span>
            </h2>
            <p className="mt-6 text-lg text-silver font-light leading-relaxed">
              Parlo di proctologia senza tabù, nella mia pagina e nel mio studio. La mia forza sono
              le persone: chi entra preoccupato deve uscire sereno, capendo tutto di quello che
              faremo insieme.
            </p>
          </Reveal>

          <div className="mt-9 space-y-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 0.07}>
                <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-card/60 px-5 py-4 transition-colors hover:border-gold/30">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gold/15 border border-gold/30 text-gold shrink-0">
                    <Check size={15} />
                  </span>
                  <p className="text-ivory/90">{p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
